<h3 style="text-align:center;font-size:1.77rem;font-weight:500">
    Contratos
</h3>

<!-- Spinner de carga -->
<div *ngIf="loadingData" class="spinner-container">
    <mat-spinner diameter="50"></mat-spinner>
</div>

<!-- Tabla de datos -->
<table mat-table id="tabla" [dataSource]="dataSource" class="mat-elevation-z5" *ngIf="!loadingData">
    <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef> ID </th>
        <td mat-cell *matCellDef="let element"> {{ element.id }} </td>
    </ng-container>

    <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef> TIPO </th>
        <td mat-cell *matCellDef="let element"> {{ element.tipo_contrato | uppercase }} </td>
    </ng-container>

    <ng-container matColumnDef="firma">
        <th mat-header-cell *matHeaderCellDef> FIRMA</th>
        <td mat-cell *matCellDef="let element">
            <span *ngIf="element.fechaFirma">{{ element.fechaFirma }}</span>
            <h2 *ngIf="!element.fechaFirma"><span class="badge badge-danger">Pendiente Firma</span></h2>
        </td>
    </ng-container>

    <ng-container matColumnDef="desde">
        <th mat-header-cell *matHeaderCellDef> DESDE </th>
        <td mat-cell *matCellDef="let element"> {{ element.fechaInicio }} </td>
    </ng-container>

    <ng-container matColumnDef="hasta">
        <th mat-header-cell *matHeaderCellDef> HASTA </th>
        <td mat-cell *matCellDef="let element"> {{ element.fechaTermino }} </td>
    </ng-container>

    <ng-container matColumnDef="acciones">
        <th mat-header-cell *matHeaderCellDef> ACCIONES </th>
        <td mat-cell *matCellDef="let element">
            <p-button class="mr-2" icon="pi pi-search" (click)="Descargar(element.id)" styleClass="p-button-rounded p-button-primary p-button-text" ></p-button>
            <p-button *ngIf="!isAuditor" class="mr-2" icon="pi pi-trash" (click)="Borrar(element.id, true)" styleClass="p-button-rounded p-button-danger p-button-text" ></p-button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
